// extracted by mini-css-extract-plugin
export default {"root":"CloODU94Wn49SBs2vPLp","info":"hxSwmRSeKjmvBiq9buPQ","danger":"WRgE6EIbqMP6r8fQwT6H","confirmation":"R48V5SeMiEnxmsj5Md42","placeHolderShimmer":"LPNV5iMnSmiAdS3EN48G"};